module.exports = __webpack_public_path__ + "files/f78b8bf800e4836d75ce79d947a235c4.png";


//////////////////
// WEBPACK FOOTER
// ./images/gitlabLogo.png
// module id = 1154
// module chunks = 76